// react components
import React, {
    useEffect,
    useRef,
    useState,
} from 'react'
import {
    IonSearchbar,
} from '@ionic/react'
import axios, {
    CancelTokenSource,
} from 'axios'
import {
    useDispatch,
    useSelector,
} from 'react-redux'

// data
import {
    contentTypeModelTypeSite,
    defaultReduxState,
    reduxFormSetRefreshSite,
    reduxModalErrorEventHandlerSite,
} from 'data'

// pages
import {
    Button825,
    DetailTabAction825,
    IconBlock825,
    InfiniteScrollHelper825,
    TableHeader825,
    TableRow825,
    TableRowDraggable825,
} from 'pages'

// serializers
import {
    ContentTypeDetailBlockInlineTypes,
    ContentTypeFieldTypes,
    ContentTypeSettingsCustomTypes,
} from 'serializers/site'

// services
import {
    axiosErrorHandlerSite,
    getApiUrlSiteV2,
    getAxiosHeadersSite,
    getInfiniteListItemSite,
    listStateInitialSite,
    listStatePropsSite,
    parseQuerySite,
} from 'services'

// props
type ListContent825Props = {
    actionSheet: string
    blockId: number
    blockInlineObject: ContentTypeDetailBlockInlineTypes
    columns: any
    contentType: contentTypeModelTypeSite
    contentTypeParent: string
    contentTypeSettingsCustom: ContentTypeSettingsCustomTypes | undefined
    defaultFields: any
    detailObject: any
    listApiUrl: string
    parentObject: any
    profile: any | undefined
    tab: number
    title?: string
}

// main
export const ListContent825: React.FC<ListContent825Props> = React.memo(({
    actionSheet,
    blockId,
    blockInlineObject,
    columns,
    contentType,
    contentTypeParent,
    contentTypeSettingsCustom,
    defaultFields,
    detailObject,
    listApiUrl,
    parentObject,
    profile,
    tab,
    title,
}) => {

    const dispatch = useDispatch()
    const searchBarRef = useRef<HTMLIonSearchbarElement>(null)
    const reduxAuth = useSelector((state: defaultReduxState) => state.reduxAuth)
    const reduxCacheSiteportfolioprofileid = useSelector((state: defaultReduxState) => state.reduxCacheSite.portfolio?.profile?.id)
    const reduxFormSite = useSelector((state: defaultReduxState) => state.reduxFormSite)
    const reduxModalSite = useSelector((state: defaultReduxState) => state.reduxModalSite)
    const reduxText = useSelector((state: defaultReduxState) => state.reduxText.data)

    // const inlineFilters = contentTypeSettingsCustom?.detail?.blockInlineAdaptation?.[blockId]?.[`inlineFilters_${detailObject.id}`] || contentTypeSettingsCustom?.detail?.blockInlineAdaptation?.[blockId]?.inlineFilters || blockInlineObject.inlineFilters || []
    const inlineFilters = blockInlineObject.inlineFilters || []

    const [axiosCancelToken, setAxiosCancelToken] = useState<CancelTokenSource | undefined>(undefined)
    const [customColumns, setCustomColumns] = useState<string[]>([])
    const [exportColumns, setExportColumns] = useState<{
        columnName: string
        columnTitle: string
        fieldOptions: ContentTypeFieldTypes | undefined
    }[]>([])
    const [exportListApiUrl, setExportListApiUrl] = useState<string>('')
    const [hoveredRow, setHoveredRow] = useState<number | null>(null)
    const [isOrdering, setIsOrdering] = useState<boolean>(false)
    const [listState, setListState] = useState<listStatePropsSite>({
        ...listStateInitialSite,
        clusterIds: [],
        modalKey: Math.random(),
    })
    const [searchValue, setSearchValue] = useState<string | null | undefined>('')
    const [tabFilterItem, setTabFilterItem] = useState<{
        name: string
        value: string
        isCustomOrdering: number | undefined
    } | undefined>(parseQuerySite(window.location.search)?.subTab ? (inlineFilters?.find((obj: any) => obj.name === parseQuerySite(window.location.search)?.subTab) || inlineFilters?.[0]) : inlineFilters?.[0])
    const [tabFilterIsCustomOrdering, setTabFilterIsCustomOrdering] = useState<boolean>(false)
    const [tabFilterString, setTabFilterString] = useState<string>(inlineFilters?.[0]?.value)
    const [userFilterOrderingCombined] = useState<boolean>(false)
    const [userFilterValues, setUserFilterValues] = useState<any>({})

    const app = contentType.split('_')[0]
    const model = contentType.split('_')[1]

    useEffect(() => {
        if (tabFilterItem) {
            onTabChange(tabFilterItem.value, tabFilterItem)
        } else {
            onGetListData(getListApiUrl(true)!, true)
        }
    }, [
        customColumns,
        listApiUrl,
    ])

    useEffect(() => {
        if (reduxFormSite.refresh.refreshDetailSite) {
            if (axiosCancelToken) axiosCancelToken.cancel('axios canceled')
            onGetListData(getListApiUrl(true)!, true, true)
        }
    }, [
        reduxFormSite.refresh.refreshDetailSite,
    ])

    function getListApiUrl(clearUserFilter?: boolean, newUserFilterValues?: any, newTabFilterString?: string, clearFilter?: boolean) {
        try {
            let newListApiUrl = getApiUrlSiteV2(listApiUrl, reduxModalSite)
            const newUserFilterValuesCombined = newUserFilterValues || userFilterValues
            if (!clearUserFilter && newUserFilterValuesCombined) {
                Object.keys(newUserFilterValuesCombined).forEach((key) => {
                    if (newUserFilterValuesCombined[key] && newUserFilterValuesCombined[key].length > 0) {
                        if (!newListApiUrl.includes('?')) newListApiUrl += '?'
                        if (key === 'order_by') {
                            newListApiUrl += `&${key}=${newUserFilterValuesCombined[key].map((val: any) => `${val.direction === '-' ? '-' : ''}${val.name}`).join(',')}`
                        } else {
                            newListApiUrl += `&${key}=${newUserFilterValuesCombined[key]}`
                        }
                    }
                })
            }
            if (columns) {
                newListApiUrl += `&fields=${columns?.join(',')}`
            }
            const newTabFilterStringCombined = newTabFilterString || (clearFilter ? '' : tabFilterString)
            if (newTabFilterStringCombined) {
                newListApiUrl += `&${newTabFilterStringCombined}`
            }
            if (clearUserFilter) {
                setUserFilterValues({})
            }
            newListApiUrl += `&__customer_profile_id=${reduxCacheSiteportfolioprofileid}`
            return newListApiUrl

        } catch (error) {
            dispatch(reduxModalErrorEventHandlerSite(
                error,
                'ListContent825',
                'getListApiUrl',
            ))
        }
    }

    function onTabChange(tabFilterString: string, tabFilterItem: {
        name: string
        value: string
        isCustomOrdering: number | undefined
    } | undefined, noSuccess?: boolean) {
        try {
            setIsOrdering(false)
            setSearchValue('')
            if (searchBarRef.current) {
                searchBarRef.current.value = ''
            }
            setTabFilterItem(tabFilterItem)
            setTabFilterIsCustomOrdering(Boolean(tabFilterItem?.isCustomOrdering || (tabFilterItem?.name === 'Affiche')))  // TODO: remove hardcoded 'Affiche'
            let newTabFilterString = tabFilterString
            if (tabFilterItem?.isCustomOrdering) {
                newTabFilterString += `&order_by_blockfilter=${tabFilterItem.isCustomOrdering}`
            }
            setTabFilterString(newTabFilterString)
            onGetListData(getListApiUrl(true, undefined, newTabFilterString, (tabFilterString ? false : true))!, true, undefined, noSuccess)
        } catch (error) {
            dispatch(reduxModalErrorEventHandlerSite(
                error,
                'ListContent825',
                'onTabChange',
            ))
        }
    }

    function onGetListData(
        apiUrl: string,
        changingView: boolean,
        noEmpty?: boolean,
        noSuccess?: boolean,
    ) {
        try {
            if (changingView) {
                setExportListApiUrl(apiUrl)
            }
            getInfiniteListItemSite({
                apiUrl,
                axiosCancelToken,
                changingView,
                component: 'ListContent825',
                dispatch,
                listState,
                noClusterIds: true,
                noEmptyItems: noEmpty,
                reduxAuth,
                reduxModalSite,
                setAxiosCancelToken,
                setListState,
                onSuccess: (e, items) => {
                    if ([4126, 4127].includes(blockId)) {  // TODO
                        if (!parseQuerySite(window.location.search)?.subTab && (items.length === 0)) {
                            if (noSuccess) return
                            onTabChange(inlineFilters[1].value, inlineFilters[1], true)
                        }
                    }
                }
            })
        } catch (error) {
            dispatch(reduxModalErrorEventHandlerSite(
                error,
                'ListContent825',
                'getListData',
            ))
        }
    }

    function onMoveRow(dragIndex: number, hoverIndex: number) {
        try {
            const newRows = [...listState.items]
            const [draggedRow] = newRows.splice(dragIndex, 1)
            newRows.splice(hoverIndex, 0, draggedRow)
            setListState({
                ...listState,
                items: newRows,
            })
            const refreshAxiosHeaders = getAxiosHeadersSite(reduxAuth, reduxModalSite, dispatch)
            const item = listState.items[dragIndex]
            const itemTo = listState.items[hoverIndex]
            const formData: any = new FormData()
            let axiosUrl = ''
            if (tabFilterItem?.isCustomOrdering) {
                formData.append('parent_id', detailObject.id)
                formData.append('item_id', item.id)
                formData.append('new_index', hoverIndex)
                axiosUrl = getApiUrlSiteV2(`setup/form/contenttypepanelblockfilter/items_position/${tabFilterItem.isCustomOrdering}/`, reduxModalSite)
            } else {
                formData.append('sibling_id', itemTo.id)
                axiosUrl = getApiUrlSiteV2(`${app}/form/${model}/position/${item.id}/`, reduxModalSite)
            }
            if (process.env.NODE_ENV === 'development') console.log(axiosUrl)
            axios({
                data: formData,
                headers: refreshAxiosHeaders,
                method: (tabFilterItem?.isCustomOrdering || tabFilterItem?.name === 'Affiche') ? 'post' : 'put',
                url: axiosUrl,
            })
                .then((response) => {
                    if (process.env.NODE_ENV === 'development') console.log(response)
                })
                .catch((error) => {
                    axiosErrorHandlerSite({
                        apiUrl: axiosUrl,
                        component: 'ListContent825',
                        dispatch,
                        error,
                        reduxAuth,
                        reduxModalSite,
                        reference: 'onMoveRow',
                    })
                })
        } catch (error) {
            dispatch(reduxModalErrorEventHandlerSite(
                error,
                'ListContent825',
                'onMoveRow',
            ))
        }
    }

    function onSearch(newSearchValue: any) {
        try {
            onSetFilter({
                params: 'search',
                value: newSearchValue,
            })
        } catch (error) {
            dispatch(reduxModalErrorEventHandlerSite(
                error,
                'ListContent825',
                'onSearch',
            ))
        }
    }

    function onSearchKeyPress(event: any) {
        try {
            if (event.key === 'Enter') {
                onSearch(event.target.value)
            }
        } catch (error) {
            dispatch(reduxModalErrorEventHandlerSite(
                error,
                'ListContent825',
                'onSearchKeyPress',
            ))
        }
    }

    function onSearchNext(isVisible: boolean) {
        try {
            if (listState.disableInfiniteScroll) return
            if (isVisible) {
                onGetListData(listState.nextUrl, false)
            }
        } catch (error) {
            dispatch(reduxModalErrorEventHandlerSite(
                error,
                'ListContent825',
                'onSearchNext',
            ))
        }
    }

    function onSetFilter(e: any) {
        try {
            setIsOrdering(false)
            if (e.params === 'order_by') {
                const order_by = userFilterOrderingCombined ? userFilterValues.order_by || [] : []
                const existingIndex = order_by.findIndex((item: any) => item.name === e.name)
                if (e.direction) {
                    if (existingIndex !== -1) {
                        order_by[existingIndex].direction = e.direction
                    } else {
                        order_by.push({
                            direction: e.direction,
                            name: e.name,
                        })
                    }
                    userFilterValues.order_by = order_by
                } else {
                    userFilterValues.order_by = order_by.filter((item: any) => item.name !== e.name)
                }
            } else {
                if (e.value) {
                    userFilterValues[e.params] = e.value
                } else {
                    delete userFilterValues[e.params]
                }
            }
            onGetListData(getListApiUrl(false, userFilterValues)!, true)
        } catch (error) {
            dispatch(reduxModalErrorEventHandlerSite(
                error,
                'ListContent825',
                'onFilter',
            ))
        }
    }

    if (blockInlineObject.hiddenIf) {
        const [hiddenIfField, hiddenIfValueRaw] = blockInlineObject.hiddenIf.split('=')
        let hiddenIfValue: any
        switch (hiddenIfValueRaw) {
            case 'true':
                hiddenIfValue = true
                break
            case 'false':
                hiddenIfValue = false
                break
            default:
                hiddenIfValue = hiddenIfValueRaw
        }
        if (detailObject[hiddenIfField] === hiddenIfValue) return null
    }

    const columns2 = customColumns.length > 0 ? customColumns : columns

    return (
        <div className='list-content-825'>
            <div className='lc-header'>
                <div className='lc-wrap-title'>
                    {title && (
                        <p className='lc-title'>{title}</p>
                    )}
                    {(inlineFilters.length > 0) && (
                        <div className='lc-filters'>
                            {inlineFilters.map((filter: any) => {
                                let toUrl = `/detail/${contentTypeParent}/${detailObject.id}`
                                const tabSearch = parseQuerySite(window.location.search)?.tab
                                if (tabSearch) {
                                    toUrl += `?tab=${tabSearch}`
                                }
                                if (filter.value) {
                                    if (toUrl.includes('?')) {
                                        toUrl += '&'
                                    } else {
                                        toUrl += '?'
                                    }
                                    toUrl += `subTab=${filter.name}`
                                }
                                return (
                                    <Button825
                                        key={filter.name}
                                        className={(tabFilterItem?.name === filter.name) ? 'lc-active' : ''}
                                        edit={false}
                                        fill='clear'
                                        justifyText='flex-start'
                                        onClick={() => onTabChange(filter.value, filter)}
                                        size='small'
                                        text={filter.name}
                                    />
                                )
                            })}
                        </div>
                    )}
                </div>
                <div className='lc-action'>
                    {listState.contentTypeSettings && (
                        <DetailTabAction825
                            contentType={contentType}
                            contentTypeSettings={listState.contentTypeSettings}
                            defaultFieldsOnAdd={blockInlineObject.defaultFieldsOnAdd}
                            detailObject={detailObject}
                            disableOrdering={Boolean(searchValue)}
                            filterParams={blockInlineObject.filterParams}
                            hasOrdering={typeof listState.items[0]?.position !== 'undefined' || tabFilterIsCustomOrdering}
                            isOrdering={isOrdering}
                            parentModelField={blockInlineObject.parentModelField}
                            parentObject={parentObject}
                            refreshData={() => dispatch(reduxFormSetRefreshSite('refreshDetailSite'))}
                            setIsOrdering={setIsOrdering}
                            subContentType={blockInlineObject.subContentType}
                            subContentTypes={blockInlineObject.subContentTypes}
                        />
                    )}
                    <div className='lc-search-wrap'>
                        <IonSearchbar
                            className='lc-searchbar'
                            onIonClear={() => onSearch('')}
                            onIonInput={(e) => setSearchValue(e.detail.value)}
                            onKeyPress={(e) => onSearchKeyPress(e)}
                            placeholder={reduxText[10243]}
                            ref={searchBarRef}
                        />
                        <IconBlock825
                            className='lc-icon'
                            edit={false}
                            iconClass='mo-new-icon-search-solid'
                            onClick={() => { if (searchBarRef.current) onSearch(searchBarRef.current.value) }}
                        />
                    </div>
                </div>
            </div>
            <div className='lc-table mo-hidden-vertical-scrollbar'>
                <table className={`${tabFilterItem?.name ? `lc-sub-tab-table-${tabFilterItem.name}` : ''}`}>
                    {listState.contentTypeSettings && (
                        <>
                            <thead>
                                <TableHeader825
                                    columns={columns2}
                                    contentType={contentType}
                                    contentTypeSettings={listState.contentTypeSettings}
                                    count={listState.count}
                                    filterValues={userFilterValues}
                                    profile={profile}
                                    setExportColumns={setExportColumns}
                                    setFilter={onSetFilter}
                                    subContentTypeId={blockInlineObject.subContentType?.id}
                                />
                            </thead>
                            <tbody>
                                {listState.items.map((item, index) => {
                                    if (isOrdering) {
                                        return (
                                            <TableRowDraggable825
                                                columns={columns2}
                                                contentType={contentType}
                                                contentTypeSettings={listState.contentTypeSettings!}
                                                index={index}
                                                isHovered={hoveredRow === index}
                                                key={item.id}
                                                modalKey={listState.modalKey}
                                                moveRow={onMoveRow}
                                                object={item}
                                                profileObject={profile}
                                                setHoveredRow={setHoveredRow}
                                            />
                                        )
                                    }
                                    return (
                                        <TableRow825
                                            key={item.id}
                                            columns={columns2}
                                            componentActionSheet={actionSheet}
                                            contentType={contentType}
                                            contentTypeSettings={listState.contentTypeSettings!}
                                            contentTypeSettingsCustom={profile?.settings_data_json?.contentTypeSettingsCustom?.[contentType]}
                                            defaultFields={defaultFields}
                                            modalKey={listState.modalKey}
                                            object={item}
                                            profileObject={profile}
                                            onSetIsDeleted={(id: number) => {
                                                setListState({
                                                    ...listState,
                                                    items: listState.items.filter((obj) => obj.id !== id),
                                                })
                                            }}
                                            refreshData={() => {
                                                if (tabFilterItem) {
                                                    onTabChange(tabFilterItem.value, tabFilterItem)
                                                } else {
                                                    onGetListData(getListApiUrl(true)!, true)
                                                }
                                            }}
                                        />
                                    )
                                })}
                            </tbody>
                        </>
                    )}
                </table>
                <InfiniteScrollHelper825
                    active={!listState.disableInfiniteScroll}
                    hasMore={listState.hasMore}
                    isLoading={listState.isLoading}
                    items={listState.items}
                    onChange={onSearchNext}
                />
            </div>
        </div>
    )
})
